import Rellax from 'rellax'
import { getElements, getOffsetTop, getOffsetLeft } from '../utils/functional'

export default class storeParallax {
  constructor (el) {
    const pageHeight = document.body.scrollHeight
    const windowHeight = window.innerHeight
    const windowWidth = window.innerWidth
    const widthToHeight = windowWidth / pageHeight

    const settings = [
      {
        name: 'shapeVertical',
        items: getElements('.prx-ShapeVertical'),
        speed: 0.25,
        horizontal: false
      },
      {
        name: 'shapeHorizontal',
        items: getElements('.prx-ShapeHorizontal'),
        speed: 0.25,
        horizontal: true
      },
      {
        name: 'StoryImage1',
        items: getElements('.prx-StoryImage-1'),
        speed: 0.1,
        horizontal: true
      },
      {
        name: 'StoryImage2',
        items: getElements('.prx-StoryImage-2'),
        speed: 0.07,
        horizontal: true
      }
    ]

    settings.forEach(setting => {
      if (setting.items.length === 0) return

      setting.items.forEach(el => {
        setTimeout(() => {
          new Rellax(el, {
            speed: setting.speed * 15,
            vertical: !setting.horizontal,
            horizontal: setting.horizontal,
            center: true
          })
        }, 500)
      })
    })
  }
}
